(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./membershipGetters", "./membershipNormalization"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./membershipGetters"), require("./membershipNormalization"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.membershipGetters, global.membershipNormalization);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _membershipGetters, _membershipNormalization) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_membershipGetters).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _membershipGetters[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _membershipGetters[key];
      }
    });
  });
  Object.keys(_membershipNormalization).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _membershipNormalization[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _membershipNormalization[key];
      }
    });
  });
});